import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { TokenService } from '../../src/utils/axios.interceptor';
import { message } from 'antd';


const RouteGuard = () => {
  let auth = { token: localStorage.getItem('accessToken') };
  let navigate = useNavigate();

  useEffect(() => {
    /*Si esta vencido el token refresh se elimina las variables del 
    local storage y se envia a la pantalla del login
    */
    TokenService.forceRefresh().then().catch(() => {
      window.localStorage.removeItem('accessToken');
      window.localStorage.removeItem('refreshToken');
      window.localStorage.removeItem('userName');
      window.localStorage.removeItem('currentUser');
      window.localStorage.removeItem('accessArray');
      navigate('/login');
      message.error('Token Expirado')
    })
  }, [])

  return auth.token ? <Outlet /> : <Navigate to={'/login'} />;
};
export default RouteGuard;